import r from "./generateUtilityClasses.mjs";
import t from "./generateUtilityClass.mjs";
function o(e) {
  return t("MuiFormHelperText", e);
}
const s = r("MuiFormHelperText", ["root", "error", "disabled", "sizeSmall", "sizeMedium", "contained", "focused", "filled", "required"]), a = s;
export {
  a as default,
  o as getFormHelperTextUtilityClasses
};
//# sourceMappingURL=formHelperTextClasses.mjs.map
